import { useState, useEffect, useCallback } from "react"; 
import { ApiIndexFieldRepository } from "../../infrastructure/repositories/ApiIndexFieldRepository";
import { GetDesignIndexFieldList } from "../UseCase/GetDesignIndexFieldList";
import useApiClient from "../../infrastructure/apiClient";

export const useGetDesignIndexFieldList = (companyId) => {
  const [designIndexFieldList, SetDesignIndexFieldList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiClient = useApiClient();

  console.log('useDesignIndexFieldList  Request : ' + companyId);

  // Extract the function to fetch the data, and make it reusable
  const getDesignIndexFieldList = useCallback(async () => {
    const indexFieldRepository = new ApiIndexFieldRepository(apiClient);
    const getDesignIndexFieldListUseCase = new GetDesignIndexFieldList(indexFieldRepository);

    try {
      setLoading(true); // Start loading when the fetch is triggered
      console.log('I am in useGetDesignIndexFieldList hook');
      const res = await getDesignIndexFieldListUseCase.execute(companyId);
      console.log('useGetDesignIndexFieldList  Response : ' + JSON.stringify(res));
      SetDesignIndexFieldList(res);
      setError(null); // Clear any previous errors if the request is successful
    } catch (err) {
      console.log('useGetDesignIndexFieldList  Exception : ' + err);
      setError(err.message);
    } finally {
      setLoading(false); // Stop loading regardless of success or failure
    }
  }, [companyId,apiClient]);

  // Call the `getIndexFieldList` function inside `useEffect` to fetch the data when the component mounts or `companyId` changes
  useEffect(() => {
    debugger;
    if (companyId === undefined || isNaN(companyId)) {
      console.log("CompanyId not defined, No API Call here.");
    } else {
      getDesignIndexFieldList();
    }
  }, [getDesignIndexFieldList,companyId]);

  // Return the state and the refetch function to trigger a manual reload
  return { designIndexFieldList, loading, error, refetch: getDesignIndexFieldList };
};

export default useGetDesignIndexFieldList;
